import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

/**
 * Sub-aba "Marcas" da aba Artículos (Operar Cliente / Área do Contador).
 *
 * Wrapper fino que reusa o componente COMPLETO (app-marca) em modo EMBUTIDO, sob o
 * contexto do cliente (X-Empresa-Contexto): consulta, ADICIONA e EDITA para o
 * cliente. Re-montado ao abrir a aba e ao trocar de cliente (padrão operar-itens).
 */
@Component({
  selector: 'app-operar-marcas',
  templateUrl: './operar-marcas.component.html',
})
export class OperarMarcasComponent implements OnChanges {
  /** Id da empresa do cliente — muda quando o contador troca de cliente. */
  @Input() clienteEmpresaId?: number | null;

  /** Indica se a sub-aba está ativa; monta o componente pesado quando abre. */
  @Input() ativo = false;

  /** Controla a existência do componente pesado (montagem sob demanda + re-mount). */
  montado = false;

  ngOnChanges(changes: SimpleChanges): void {
    const abriuAgora =
      !!changes['ativo'] && this.ativo && changes['ativo'].previousValue !== true;
    const trocouCliente =
      !!changes['clienteEmpresaId'] && !changes['clienteEmpresaId'].firstChange;

    if (changes['ativo'] && !this.ativo) {
      this.montado = false;
      return;
    }

    if (abriuAgora || (trocouCliente && this.ativo)) {
      if (this.montado) {
        this.montado = false;
        Promise.resolve().then(() => {
          this.montado = true;
        });
      } else {
        this.montado = true;
      }
    }
  }
}
